import { Button, Drawer, Typography } from "antd";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { keycloak } from "../../..";
import { useAppSelector } from "../../../app/store";
import Loader from "../../../components/ui/Loader";
import {
  useGetAllAssignProjectQuery,
  useGetSingleCompanyQuery,
} from "../../../features/portal/companyOnboard/companyOnboardApi";
import {
  useGetAllProductQuery,
  useGetProjectsByUserQuery,
  useLazyCheckUserBelongProjectQuery,
} from "../../../features/portal/Products/productsApi";
import { useGetDashboardDataQuery } from "../../../features/portal/user/userApi";
import useError from "../../../hooks/useError";
import useModal from "../../../hooks/useModal";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { toast } from "../../../lib/toast";
import { createHash } from "../../../utils/hash";
import {
  buildProductLaunchUrl,
  resolveLocalDigigoRedirectUri,
} from "../../../utils/redirectUri";

type KeywordType = {
  projectId: number;
  dynamicId: any;
  dynamicKeyword: any;
};

export default function DashboardV3() {
  const Statistic = ({
    title,
    value,
    icon: Icon,
    bgColor,
    iconColor,
  }: {
    title: string;
    value: string | number;
    icon: (props: { iconColor?: string }) => JSX.Element;
    bgColor: string;
    iconColor: string;
  }) => {
    return (
      <div className="flex gap-2 items-center bg-white">
        <div
          className="h-full flex items-center p-2"
          style={{ background: bgColor }}
        >
          <Icon iconColor={iconColor} />
        </div>
        <div className="p-2">
          <div className="font-bold text-[36px]">{value}</div>
          <div className="text-[#8897AE]">{title}</div>
        </div>
      </div>
    );
  };

  const { Text } = Typography;
  const [selectedSupplierId, setSelectedSupplierId] = useState<number | null>(
    null
  );

  const [blockedProjectId, setBlockedProjectId] = useState<number | null>(null);
  const navigate = useNavigate();

  const {
    open: openDynamicModal,
    handleOpen: handleDynamicOpen,
    handleClose: handleDynamicClose,
  } = useModal<undefined, "CONFIRM">();

  const [modalActionData, setModalActionData] = useState<{
    redirectUri: string;
    logo?: string;
    payload?: any;
    redirectToAnotherWebsite?: boolean;
  } | null>(null);
  const [open, setOpen] = useState(false);

  const { user, role } = useAppSelector((state) => state.auth);
  const { isError, error, isLoading, data } = useGetProjectsByUserQuery({
    params: {
      userid: user?.data?.id,
    },
  });
  const {
    isError: isCompanyError,
    error: companyError,
    isLoading: isCompanyLoading,
    data: companyData,
  } = useGetSingleCompanyQuery(user?.data?.company_id || "", {
    skip: !user?.data?.company_id,
  });

  const {
    isLoading: isAllProductLoading,
    isError: isAllProductError,
    error: allProductError,
    data: getAllProduct,
  } = useGetAllProductQuery({
    params: {
      status: true,
      limit: 100000,
      isDraft: "true",
    },
  });

  const {
    isLoading: getDashboardDataIsLoading,
    isError: getDashboardDataIsError,
    error: getDashboardDataError,
    data: getDashboardData,
  } = useGetDashboardDataQuery({
    params: {
      company_id: role === "SUPER_ADMIN" ? undefined : user?.data?.company_id,
    },
  });

  const companyId = user?.data?.company_id
    ? Number(user?.data?.company_id)
    : undefined;

  const {
    isError: getAllAssignProjectIsError,
    error: getAllAssignProjectError,
    isLoading: getAllAssignProjectIsLoading,
    data: getAllAssignProject,
  } = useGetAllAssignProjectQuery(
    { id: companyId as number, search: undefined },
    {
      skip: !companyId, // only run when companyId exists
    }
  );

  const [triggerCheckUserBelongProject] = useLazyCheckUserBelongProjectQuery();

  useEffect(() => {
    if (
      (user?.data?.status === "invited" || user?.data?.is_account_hold) &&
      user?.data?.id
    ) {
      navigate(`/admin/employees/view/${user.data.id}`);
    }
  }, [navigate, user?.data?.id, user?.data?.is_account_hold, user?.data?.status]);

  useError(isAllProductError, allProductError, "Get all product fail");
  useError(isError, error, "User get fail");
  useError(isCompanyError, companyError, "Company get fail");
  useError(
    getDashboardDataIsError,
    getDashboardDataError,
    "Dashboard data get fail"
  );
  useError(
    getAllAssignProjectIsError,
    getAllAssignProjectError,
    "User details get fail"
  );

  // console.log(companyData?.data?.dynamicId, companyData?.data?.dyncamicKeyword);

  // const handleSelectSupplier = () => {
  //   if (!modalActionData) return;

  //   const { redirectUri, logo, payload, redirectToAnotherWebsite } =
  //     modalActionData;

  //   // Call the original functions now
  //   if (redirectToAnotherWebsite) {
  //     handleRedirect(redirectUri, payload);
  //   } else {
  //     handleProject(redirectUri, logo, payload);
  //   }

  //   handleDynamicClose();
  // };

  // const selectedSupplier = companyData?.data?.dynamicKeys?.find(
  //   (item: any) => item.id === selectedSupplierId
  // );

  const selectedSupplier = companyData?.data?.dynamicKeys?.[0];
  const isCompanyPublished =
    typeof companyData?.data?.is_published === "number"
      ? companyData?.data?.is_published === 1
      : typeof companyData?.data?.is_published === "boolean"
      ? companyData?.data?.is_published
      : companyData?.data?.status?.toLowerCase() !== "unpublished";

  const handleProject = (
    // role: string,
    redirectUri: string,
    projectLogo: any,
    { projectId }: KeywordType
  ) => {
    const finalRedirectUri = resolveLocalDigigoRedirectUri(redirectUri);
    const matchedRole = data?.data?.find(
      (item: any) => item?.project?.id === projectId
    );

    const roleName = matchedRole?.role?.roleName;
    const projectName = matchedRole?.project?.name;

    // ✅ Set roleName to localStorage
    if (roleName) {
      localStorage.setItem("project_role", roleName);
    }

    if (projectName) {
      localStorage.setItem("product_name", projectName);
    }

    // localStorage.setItem("project_role", role);
    localStorage.setItem("product_id", String(projectId));
    localStorage.setItem("product_logo", String(projectLogo));
    const dynamicId = companyData?.data?.dynamicId;
    const dynamicKeyword = companyData?.data?.dyncamicKeyword;
    // const dynamicId = selectedSupplier?.dynamic_id;
    // const dynamicKeyword = selectedSupplier?.dynamic_keyword;

    // if (!dynamicId || !dynamicKeyword) {
    //   toast("error", "Please set dynamic id and dynamic keyword");
    //   return;
    // }

    // console.log("projectId Check", projectId);

    const pId = projectId ? createHash(String(projectId)) : "";
    const dId = dynamicId ? createHash(String(dynamicId)) : "";
    const dText = dynamicKeyword ? createHash(String(dynamicKeyword)) : "";

    const url = buildProductLaunchUrl(finalRedirectUri, {
      projectType: pId,
      dynamicId: dId,
      dynamicKeyword: dText,
      token: keycloak?.token,
    });

    const bsrm_url = "/admin/bsrm/dashboard";

    const cash_collection_url = "/admin/cash-dashboard";

    if (finalRedirectUri?.includes(bsrm_url)) {
      localStorage.setItem("BSRM_USER", "BSRM_USER");
    }

    if (finalRedirectUri?.includes(cash_collection_url)) {
      localStorage.setItem("BSRM_USER", "CASH_USER");
    }

    if (finalRedirectUri) window.location.assign(url);
    // navigate("/admin/salary-disbursement/batch");
  };

  const handleRedirect = (
    // role: string,
    redirectUri: string,
    { projectId, dynamicId, dynamicKeyword }: KeywordType
  ) => {
    const finalRedirectUri = resolveLocalDigigoRedirectUri(redirectUri);
    // localStorage.setItem("project_role", role);
    if (finalRedirectUri) {
      const pId = projectId ? createHash(String(projectId)) : "";
      const dId = dynamicId ? createHash(String(dynamicId)) : "";
      const dText = dynamicKeyword ? createHash(String(dynamicKeyword)) : "";

      const url = buildProductLaunchUrl(finalRedirectUri, {
        projectType: pId,
        dynamicId: dId,
        dynamicKeyword: dText,
        token: keycloak?.token,
      });

      // console.log(url);

      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
    setBlockedProjectId(null);
  };

  const filteredProject = getAllProduct?.data?.data?.find(
    (item: any) => item.id === blockedProjectId
  );

  // truncate
  //   group-hover:whitespace-normal
  //   group-hover:overflow-visible
  //   group-hover:truncate-none
  //   group-hover:break-words
  //   transition-all duration-300
  return (
    <>
      <SidebarLayout
        title=""
        isLogoTitle
        isHide
        className="!min-h-[calc(100vh-80px)] !overflow-hidden !p-0"
      >
        {isLoading ||
        isCompanyLoading ||
        getDashboardDataIsLoading ||
        isAllProductLoading ||
        getAllAssignProjectIsLoading ? (
          <Loader />
        ) : (
          <div
            className="relative w-full !min-h-[calc(100vh-80px)] !overflow-hidden mt-10 mb-10"
            // style={{ backgroundImage: `url(${BGImage})` }}
          >
            <div className="w-[95%] sm:w-[90%] md:w-[90%] lg:w-[90%] xl:w-[80%] mx-auto">
              <div className="self-stretch justify-start text-zinc-700 text-xl md:text-2xl font-semibold mb-5">
                👋 Welcome to Sheba Business{" "}
              </div>

              <div className="self-stretch justify-start text-slate-500 text-sm md:text-base font-normal">
                Your workspace is ready to roll. From HR to vendor management,
                payments to operations — everything you need sits in one
                powerful platform.
                <br />
                Let’s make today sharper, faster, and more productive. 🚀
              </div>
              {!isCompanyPublished && role !== "SUPER_ADMIN" ? (
                <div className="mt-6 rounded-md border border-red-200 bg-red-50 p-3 text-sm font-medium text-red-600">
                  This business is currently unpublished. App access is disabled
                  until the business is published again.
                </div>
              ) : null}

              {companyData?.data?.can_view_all_products === true ? (
                <>
                  <div className="mt-10">
                    {role === "SUPER_ADMIN" ? (
                      <div
                        className={`grid grid-cols-3 sm:grid-cols-6 lg:grid-cols-9 gap-4 !rounded-lg w-full cursor-pointer transition-all duration-300`}
                      >
                        {getAllProduct?.data?.data.map((val, index) => {
                          return (
                            <div key={index}>
                              <div
                                className="    
    group
    w-28        
    p-2 rounded-md flex flex-col items-center justify-start gap-2 mb-6
    transition-[max-height] duration-300 ease-in-out
    border border-transparent
    hover:border-[#F05323] hover:bg-[#FEEEE9]"
                              >
                                <div className="w-14 h-14 flex items-center justify-center">
                                  <img
                                    className="w-14 h-14 object-contain"
                                    src={val?.logo}
                                    alt="project_logo"
                                  />
                                </div>

                                <div
                                  className="
      text-center text-zinc-700 text-sm leading-tight
      w-full                              
    "
                                >
                                  {val?.name}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div
                        className={`grid grid-cols-3 sm:grid-cols-6 lg:grid-cols-9 gap-4 !rounded-lg w-full cursor-pointer transition-all duration-300`}
                      >
                        {getAllProduct?.data?.data.map((val, index) => {
                          return (
                            <div
                              key={index}
                              onClick={() => {
                                if (!isCompanyPublished) {
                                  toast(
                                    "warning",
                                    "Business is unpublished. Publish it to use apps."
                                  );
                                  return;
                                }
                                if (!val?.redirectUri?.trim()) return;

                                triggerCheckUserBelongProject({
                                  params: { projectId: val?.id },
                                })
                                  .unwrap()
                                  .then((response) => {
                                    const exists = response?.data?.exists;

                                    if (!exists) {
                                      // toast(
                                      //   "warning",
                                      //   "To access this feature, please purchase a subscription plan or contact Sheba Admin"
                                      // );
                                      setBlockedProjectId(val?.id);
                                      showDrawer();
                                      return;
                                    }

                                    // Prepare payload based on is_dynamic_key
                                    const payload = {
                                      projectId: val.id,
                                      dynamicId: val.is_dynamic_key
                                        ? selectedSupplier?.dynamic_id
                                        : val?.dynamicId,
                                      dynamicKeyword: val.is_dynamic_key
                                        ? selectedSupplier?.dynamic_keyword
                                        : val?.dyncamicKeyword,
                                    };

                                    if (val.is_dynamic_key) {
                                      // 🔹 Instead of opening modal → call functions directly
                                      if (val.redirectToAnotherWebsite) {
                                        handleRedirect(
                                          val.redirectUri.trim(),
                                          payload
                                        );
                                      } else {
                                        handleProject(
                                          val.redirectUri.trim(),
                                          val.logo,
                                          payload
                                        );
                                      }
                                    } else {
                                      // If is_dynamic_key === false
                                      if (val.redirectToAnotherWebsite) {
                                        handleRedirect(
                                          val.redirectUri.trim(),
                                          payload
                                        );
                                      } else {
                                        handleProject(
                                          val.redirectUri.trim(),
                                          val.logo,
                                          payload
                                        );
                                      }
                                    }
                                  })
                                  .catch(() =>
                                    toast("error", "Something went wrong")
                                  );
                              }}
                            >
                              <div
                                className="    
    group
    w-28        
    p-2 rounded-md flex flex-col items-center justify-start gap-2 mb-6
    transition-[max-height] duration-300 ease-in-out
    border border-transparent
    hover:border-[#F05323] hover:bg-[#FEEEE9]"
                                style={{
                                  opacity: isCompanyPublished ? 1 : 0.45,
                                  cursor: isCompanyPublished
                                    ? "pointer"
                                    : "not-allowed",
                                }}
                              >
                                <div className="w-14 h-14 flex items-center justify-center">
                                  <img
                                    className="w-14 h-14 object-contain"
                                    src={val?.logo}
                                    alt="project_logo"
                                  />
                                </div>

                                <div
                                  className="
      text-center text-zinc-700 text-sm leading-tight
      w-full                              
    "
                                >
                                  {val?.name}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <div className="mt-10">
                    {role === "SUPER_ADMIN" ? (
                      <div
                        className={`grid grid-cols-3 sm:grid-cols-6 lg:grid-cols-9 gap-4 !rounded-lg w-full cursor-pointer transition-all duration-300`}
                      >
                        {getAllAssignProject?.data?.projects.map(
                          (val, index) => {
                            return (
                              <div key={index}>
                                <div
                                  className="    
    group
    w-28        
    p-2 rounded-md flex flex-col items-center justify-start gap-2 mb-6
    transition-[max-height] duration-300 ease-in-out
    border border-transparent
    hover:border-[#F05323] hover:bg-[#FEEEE9]"
                                >
                                  <div className="w-14 h-14 flex items-center justify-center">
                                    <img
                                      className="w-14 h-14 object-contain"
                                      src={val?.project_logo}
                                      alt="project_logo"
                                    />
                                  </div>

                                  <div
                                    className="
      text-center text-zinc-700 text-sm leading-tight
     w-full   
    "
                                  >
                                    {val?.project_name}
                                  </div>
                                </div>
                              </div>
                            );
                          }
                        )}
                      </div>
                    ) : (
                      <div
                        className={`grid grid-cols-3 sm:grid-cols-6 lg:grid-cols-9 gap-4 !rounded-lg w-full cursor-pointer transition-all duration-300`}
                      >
                        {getAllAssignProject?.data?.projects.map(
                          (val, index) => {
                            return (
                              <div
                              key={index}
                              onClick={() => {
                                if (!isCompanyPublished) {
                                  toast(
                                    "warning",
                                    "Business is unpublished. Publish it to use apps."
                                  );
                                  return;
                                }
                                if (!val?.redirectUri?.trim()) return;

                                  triggerCheckUserBelongProject({
                                    params: { projectId: val?.project_id },
                                  })
                                    .unwrap()
                                    .then((response) => {
                                      const exists = response?.data?.exists;

                                      if (!exists) {
                                        // toast(
                                        //   "warning",
                                        //   "To access this feature, please purchase a subscription plan or contact Sheba Admin"
                                        // );
                                        setBlockedProjectId(val?.project_id);
                                        showDrawer();
                                        return;
                                      }

                                      // Prepare payload based on is_dynamic_key
                                      const payload = {
                                        projectId: val.project_id,
                                        dynamicId: val.is_dynamic_key
                                          ? selectedSupplier?.dynamic_id
                                          : val?.dynamicId,
                                        dynamicKeyword: val.is_dynamic_key
                                          ? selectedSupplier?.dynamic_keyword
                                          : val?.dyncamicKeyword,
                                      };

                                      if (val.is_dynamic_key) {
                                        // 🔹 Instead of opening modal → call functions directly
                                        if (val.redirectToAnotherWebsite) {
                                          handleRedirect(
                                            val.redirectUri.trim(),
                                            payload
                                          );
                                        } else {
                                          handleProject(
                                            val.redirectUri.trim(),
                                            val.project_logo,
                                            payload
                                          );
                                        }
                                      } else {
                                        // If is_dynamic_key === false
                                        if (val.redirectToAnotherWebsite) {
                                          handleRedirect(
                                            val.redirectUri.trim(),
                                            payload
                                          );
                                        } else {
                                          handleProject(
                                            val.redirectUri.trim(),
                                            val.project_logo,
                                            payload
                                          );
                                        }
                                      }
                                    })
                                    .catch(() =>
                                      toast("error", "Something went wrong")
                                    );
                                }}
                              >
                                <div
                                  className="    
    group
    w-28        
    p-2 rounded-md flex flex-col items-center justify-start gap-2 mb-6
    transition-[max-height] duration-300 ease-in-out
    border border-transparent
    hover:border-[#F05323] hover:bg-[#FEEEE9]"
                                  style={{
                                    opacity: isCompanyPublished ? 1 : 0.45,
                                    cursor: isCompanyPublished
                                      ? "pointer"
                                      : "not-allowed",
                                  }}
                                >
                                  <div className="w-14 h-14 flex items-center justify-center">
                                    <img
                                      className="w-14 h-14 object-contain"
                                      src={val?.project_logo}
                                      alt="project_logo"
                                    />
                                  </div>

                                  <div
                                    className="
      text-center text-zinc-700 text-sm leading-tight
      w-full                              
    "
                                  >
                                    {val?.project_name}
                                  </div>
                                </div>
                              </div>
                            );
                          }
                        )}
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </SidebarLayout>

      <Drawer open={open} width={500} onClose={onClose}>
        <div className="flex items-center justify-start gap-2">
          <div className="w-14 h-14 flex items-center justify-center">
            <img
              className="w-14 h-14 object-contain"
              src={filteredProject?.logo}
              alt="project_logo"
            />
          </div>

          <div className="text-[#1f285d] font-bold text-2xl">
            {filteredProject?.name}
          </div>
        </div>

        <div>
          {filteredProject?.projectFeatures?.map((item) => (
            <div className="mt-10 mb-5" key={item?.id}>
              {item?.feature_image && (
                <>
                  <div className="w-full h-full mb-8">
                    <img src={item?.feature_image} alt="feature_image" />
                  </div>
                </>
              )}

              {item?.details && (
                <>
                  <div
                    className="prose max-w-none product-dowar"
                    dangerouslySetInnerHTML={{ __html: item.details }}
                  />
                </>
              )}

              {item?.button && (
                <Link to={item?.button_link}>
                  <Button
                    type="primary"
                    size="middle"
                    className="mt-5 px-3.5 py-2 !bg-pink-700 !hover:bg-pink-800 inline-flex justify-center items-center text-white text-sm font-semibold gap-2.5 !rounded-[100px]"
                  >
                    {item?.button}
                  </Button>
                </Link>
              )}
            </div>
          ))}
        </div>
      </Drawer>
    </>
  );
}
